import { render } from "./DentalBridgesAltSolutions.vue?vue&type=template&id=11aacc19"
import script from "./DentalBridgesAltSolutions.vue?vue&type=script&lang=js"
export * from "./DentalBridgesAltSolutions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__